import { handleActions } from 'redux-actions';
import { OptionState } from '../constants/model';
import Immutable from 'immutable';

const optionReducer = handleActions({
    SET_OPTION: (state, { payload })=>{
        return state.set( payload.field, Immutable.fromJS(payload.options))
    },
    SET_OPTIONLOADING: (state, { payload })=>{
        return state.set( 'loading', payload.loading)
    },

}, OptionState)

export default optionReducer
